export const ANALYTICS_EVENTS = {
  // Activity
  STUDENT_VIEW_REMARKS_BUTTON_CLICKED: 'student_view_remarks_button_clicked',

};

export const ANALYTICS_PARAMS = {
  STATUS: 'status',           // 'success' | 'failed'
  STATUS_CODE: 'status_code',
  REASON: 'reason',
};

export const ANALYTICS_STATUS = {
  SUCCESS: 'success',
  FAILED: 'failed',
};
